var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "runningplanEdit",
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: "68%",
        "before-close": _vm.handleClose,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, size: "small" } },
        [
          _c(
            "div",
            { staticClass: "tipsBox", staticStyle: { margin: "0 0 5px 90px" } },
            [
              _c("img", {
                staticStyle: { width: "20px", height: "20px" },
                attrs: { src: require("./static/tips.png") },
              }),
              _c("span", [_vm._v("若该班次未产生订单，可修改班次时间！")]),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "班次时间：" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("avue-date", {
                        attrs: {
                          type: "date",
                          format: "yyyy-MM-dd",
                          valueFormat: "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.departureDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "departureDate", $$v)
                          },
                          expression: "form.departureDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { display: "flex" }, attrs: { span: 6 } },
                    [
                      !_vm.timeRangeShow
                        ? _c("el-time-picker", {
                            key: "pickerRangeType",
                            attrs: {
                              "picker-options": {
                                selectableRange: "00:00:00 - 23:59:59",
                              },
                              "value-format": "HH:mm",
                              format: "HH:mm",
                              placeholder: "请选择班次时间",
                              size: "small",
                              clearable: false,
                            },
                            on: { change: _vm.handlePlanTime },
                            model: {
                              value: _vm.form.departureTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "departureTime", $$v)
                              },
                              expression: "form.departureTime",
                            },
                          })
                        : _c("el-time-picker", {
                            key: "pickerType",
                            staticStyle: { width: "200px" },
                            attrs: {
                              "is-range": "",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              placeholder: "选择时间范围",
                              format: "HH:mm",
                              clearable: false,
                              "value-format": "timestamp",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.timeRangeChange($event)
                              },
                            },
                            model: {
                              value: _vm.form.timeRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "timeRange", $$v)
                              },
                              expression: "form.timeRange",
                            },
                          }),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["transport_runningplan_range"],
                              expression: "['transport_runningplan_range']",
                            },
                          ],
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              _vm.timeRangeShow = !_vm.timeRangeShow
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.timeRangeShow ? "返回" : "区间发班") +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "班次状态：" } },
            [
              _c("avue-select", {
                attrs: {
                  placeholder: "请选择班次状态",
                  dic: [
                    { label: "开班", value: 1 },
                    { label: "停班", value: 2 },
                  ],
                },
                model: {
                  value: _vm.form.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "status", $$v)
                  },
                  expression: "form.status",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "tipsBox",
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px",
                  },
                },
                [
                  _c("img", {
                    staticStyle: {
                      "vertical-align": "middle",
                      width: "20px",
                      height: "20px",
                    },
                    attrs: { src: require("./static/tips.png") },
                  }),
                  _c("span", [_vm._v("停班后乘客不可选择该班次下单！")]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tipsBox", staticStyle: { "margin-left": "5px" } },
            [
              _c("img", {
                staticStyle: { width: "20px", height: "20px" },
                attrs: { src: require("./static/tips.png") },
              }),
              _c("span", [
                _vm._v(
                  "价格方案和车座相关，请谨慎修改，可在详情页点击修改价格！"
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格方案：" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("avue-select", {
                        attrs: {
                          placeholder: "请选择座位",
                          dic: _vm.seatDic,
                          props: { label: "seatName", value: "seats" },
                        },
                        on: { change: _vm.handleSeateNumSelect },
                        model: {
                          value: _vm.form.seat,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "seat", $$v)
                          },
                          expression: "form.seat",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("avue-select", {
                        attrs: {
                          placeholder: "请选择车型",
                          disabled: _vm.carTypeDisabled,
                          props: { label: "carType", value: "type" },
                          dic: _vm.carTypeDic,
                        },
                        on: { change: _vm.handleSelectPriceMthod },
                        model: {
                          value: _vm.form.carType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "carType", $$v)
                          },
                          expression: "form.carType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("avue-select", {
                        attrs: {
                          placeholder: "请选择价格方案",
                          props: {
                            label: "priceMethodName",
                            value: "priceMethodId",
                          },
                          dic: _vm.priceMethodDic,
                        },
                        model: {
                          value: _vm.form.priceMethodId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priceMethodId", $$v)
                          },
                          expression: "form.priceMethodId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          false
            ? _c(
                "el-form-item",
                { attrs: { label: "站点开关：" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tipsBox",
                      staticStyle: { margin: "0 0 5px 0px" },
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: { src: require("./static/tips.png") },
                      }),
                      _c("span", [
                        _vm._v("站点关闭后乘客无法在该站点下单，谨慎关闭！"),
                      ]),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.data,
                        border: "",
                        size: "small",
                        "max-height": "200px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", align: "center", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.index + 1) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2072002521
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "类型", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.index === _vm.start
                                    ? _c("div", [_vm._v("起点")])
                                    : _vm._e(),
                                  scope.row.index > _vm.start &&
                                  scope.row.index < _vm.end
                                    ? _c("div", [_vm._v("经过")])
                                    : _vm._e(),
                                  scope.row.index === _vm.end
                                    ? _c("div", [_vm._v("终点")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3288239798
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "站点名称",
                          align: "center",
                          prop: "stationName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "上下车规则", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.rule) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2894459507
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "是否关闭站点", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("avue-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      dic: [{ value: 2 }, { value: 1 }],
                                    },
                                    model: {
                                      value: scope.row.enable,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "enable", $$v)
                                      },
                                      expression: "scope.row.enable",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2128447042
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "运力信息：" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.handleMmpVar(_vm.info)
                    },
                  },
                },
                [_vm._v("调整运力")]
              ),
              _vm.modifyDriverDialog
                ? _c("modify-driver", {
                    ref: "modifyDriver",
                    on: { refreshData: _vm.refreshData },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.capacityInfoVOS,
                    border: "",
                    size: "small",
                    "max-height": "200px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "出车顺序", align: "center", prop: "sort" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "状态",
                      align: "center",
                      prop: "driverStatus",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "司机姓名",
                      align: "center",
                      prop: "driverName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "司机电话",
                      align: "center",
                      prop: "driverPhoneNum",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车牌号", align: "center", prop: "carNum" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车型", align: "center", prop: "carType" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签：" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "160",
                    trigger: "manual",
                  },
                  model: {
                    value: _vm.labelVisible,
                    callback: function ($$v) {
                      _vm.labelVisible = $$v
                    },
                    expression: "labelVisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.labelLoading,
                          expression: "labelLoading",
                        },
                      ],
                      staticStyle: {
                        padding: "0px 0px 20px 20px",
                        "max-height": "200px",
                        "overflow-y": "scroll",
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { max: 2 },
                          model: {
                            value: _vm.labelCheck,
                            callback: function ($$v) {
                              _vm.labelCheck = $$v
                            },
                            expression: "labelCheck",
                          },
                        },
                        _vm._l(_vm.labelCheckList, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.label,
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: item.type } },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["edit_label"],
                                      expression: "['edit_label']",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    type: "text",
                                    icon: "el-icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAdd(item, "edit")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                编辑\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex flex-justify-between" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["add_label"],
                                expression: "['add_label']",
                              },
                            ],
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAdd({}, "add")
                              },
                            },
                          },
                          [_vm._v("\n              添加\n            ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                _vm.labelVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.submitLabel()
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-labels",
                      attrs: { slot: "reference", type: "text" },
                      on: { click: _vm.addLabels },
                      slot: "reference",
                    },
                    [_vm._v("\n          添加\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                _vm._l(_vm.labels, function (item, index) {
                  return _c(
                    "el-tag",
                    {
                      key: index,
                      staticStyle: { "margin-right": "5px" },
                      attrs: { closable: "", type: "warning", size: "small" },
                      on: {
                        close: function ($event) {
                          return _vm.handleCloseLabel(index)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.labelCheckList.filter(function (it) {
                              return +it.type === +item
                            })[0].name
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.labels.length > 0
        ? _c(
            "el-form-item",
            { attrs: { label: "选择置顶标签：" } },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.handleLabelChange },
                  model: {
                    value: _vm.form.topLableIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "topLableIds", $$v)
                    },
                    expression: "form.topLableIds",
                  },
                },
                _vm._l(_vm.labels, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item, attrs: { label: item } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.labelCheckList.filter(function (it) {
                              return +it.type === +item
                            })[0].name
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticStyle: { margin: "20px 0 10px 0" },
          attrs: { loading: _vm.logLoading, size: "small", type: "primary" },
          on: { click: _vm.showLogData },
        },
        [
          _vm._v("\n    操作日志\n    "),
          !_vm.showLog
            ? _c("i", { staticClass: "el-icon-arrow-right" })
            : _c("i", { staticClass: "el-icon-arrow-down" }),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "el-fade-in-linear" } },
        [
          _c("operation-log", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLog,
                expression: "showLog",
              },
            ],
            attrs: { visible: _vm.showLog, flightPlanId: this.flightId },
          }),
        ],
        1
      ),
      _c("AddLabel", { ref: "addLabel", on: { close: _vm.getLabelList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }